module.exports = __webpack_public_path__ + "static/media/Laugo_19.e89e44a8.jpg";